import { render } from "./Turntable.vue?vue&type=template&id=00aba2da&scoped=true"
import script from "./Turntable.vue?vue&type=script&lang=js"
export * from "./Turntable.vue?vue&type=script&lang=js"

import "./Turntable.vue?vue&type=style&index=0&id=00aba2da&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/simple-city-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00aba2da"]])

export default __exports__